module.exports = __webpack_public_path__ + "img/locomotive.05829164.gif";